import { Navigate} from "react-router-dom"


function ProtectedRouteOut({auth, children }) {   
    return auth ? children : <Navigate to="/login"/>;
   
}
export default ProtectedRouteOut